import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { RevenueReportForOwnerComponent } from "../revenue-report-for-owner/revenue-report-for-owner.component";


@NgModule({
  declarations: [
    RevenueReportForOwnerComponent
  ],

  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],

  exports: [
    RevenueReportForOwnerComponent
  ]
})
export class RevenueReportModule {}